import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import { SendDeliveryByEmail } from './SendDeliveryByEmail'
import { SendDeliveryBySMS } from './SendDeliveryBySMS'
import {ICONS} from "../../../components";

export const DeliveryCommunication = ({ ticket, children }) => {
  return (
    <div>
      {ticket.can_print_delivery_report.flag ? <ReactBootstrap.Dropdown  size="lg">
        <ReactBootstrap.Dropdown.Toggle block variant="outline-success">
          Send Delivery Details
        </ReactBootstrap.Dropdown.Toggle>

        <ReactBootstrap.Dropdown.Menu>
          <SendDeliveryByEmail ticket={ticket} />
          <SendDeliveryBySMS ticket={ticket} />
        </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>:<>{ICONS.ERROR}  Delivery info can only be sent once delivery information is  filled.</>}
    </div>
  )
}
